import React, { useState } from "react";
import Cookies from "js-cookie";
import { connect } from "react-redux";
import * as actionTypes from "../../../store/actions";
import { Formik, Field, Form } from "formik";
import { useNavigate, useLocation } from "react-router-dom";
import Overlay from "../../../components/Overlay";
import { toast } from "react-toastify";
import { makeStyles } from "@material-ui/core/styles";
import jobDashLogo from "../../../assets/images/jobDashlogo.png";
import InputLogin from "../../../components/InputLogin";
import { IoArrowBackOutline } from "react-icons/io5";
import axios from "../../../axios";

console.log("welcome");
console.log("cookies object", Cookies);

const useStyles = makeStyles((theme) => ({
  formStyle: {
    width: "100%",
    // padding: "2rem",
    overflow: "auto",
  },
  "@media (max-width: 780px)": {
    formStyle: {
      padding: "1.8rem",
    },
  },
  "@media (max-width: 480px)": {
    formStyle: {
      padding: "1.3rem",
    },
  },
}));

// Simple validator only for email
const emailValidator = (values) => {
  const errors = {};
  if (!values.email) {
    errors.email = "Email is required";
  } else if (
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
  ) {
    errors.email = "Invalid email address";
  }
  return errors;
};

const Email = ({ setUsers, userData }) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();

  const [isLoading, setIsLoading] = useState(false);

  const initialValues = {
    email: "",
  };

  const handleSendOTP = async (values) => {
    setIsLoading(true);

    const formvalues = {
      email: values.email,
    };

    try {
      const response = await axios.post("/sendOtpForForgetpassword", formvalues);

      console.log("responsefrg", response?.data?.data?._id);

      if (response?.status === 200) {
        // Save OTP data in localStorage
        localStorage.setItem("otpData", JSON.stringify({
          email: values.email,
          userId: response?.data?.data?._id,  // or whatever property comes in `data`
        }));

        toast.success("OTP sent successfully!", {
          position: "top-right",
        });

        navigate("/otpVerify", {
          state: { email: values.email },
        });
      }
    } catch (error) {
      const status = error?.response?.status;

      if (status === 422) {
        toast.error(
          error?.response?.data?.errors?.[0]?.msg || "Validation error",
          { position: "top-right" }
        );
      } else if (status === 404) {
        toast.error("Invalid Email Address", {
          position: "top-right",
        });
      } else {
        toast.error(
          error?.response?.data?.message || "Something went wrong",
          { position: "top-right" }
        );
      }
    } finally {
      setIsLoading(false);
    }
  };



  return (
    <>
      <section className="auth">
        <div className="login">
          <div className="login-text-cant">
            <img
              src={jobDashLogo}
              alt="JobDash Logo"
              style={{ height: "75.78px", width: "97px" }}
            />
          </div>
          <div className="logincontainer">
            <div className="login-main-cant">
              <div className="form">
                <Formik
                  enableReinitialize
                  initialValues={initialValues}
                  validate={emailValidator}
                  validateOnChange
                  onSubmit={handleSendOTP}
                >
                  {(formikBag) => (
                    <Form className={classes.formStyle}>
                      <div>
                        <label>Email ID</label>
                        <Field name="email">
                          {({ field }) => (
                            <div className="py-2">
                              <div className="form-controlcont">
                                <InputLogin
                                  {...field}
                                  type="email"
                                  onChange={(e) => {
                                    formikBag.setFieldValue(
                                      "email",
                                      e.target.value
                                    );
                                  }}
                                  className="form-control login-placeholder"
                                  placeholder="Enter Email ID"
                                />
                              </div>
                              <p className="error">
                                {formikBag.touched.email &&
                                  formikBag.errors.email
                                  ? formikBag.errors.email
                                  : null}
                              </p>
                            </div>
                          )}
                        </Field>
                      </div>

                      <button
                        type="submit"
                        disabled={isLoading || !formikBag.isValid}
                      >
                        {isLoading ? "Sending..." : "Verify Email"}
                      </button>
                    </Form>
                  )}
                </Formik>
                <div
                  className="forgotText"
                  onClick={() => {
                    navigate("/");
                  }}
                >
                  <IoArrowBackOutline /> Back to login page
                </div>
              </div>


            </div>
          </div>
        </div>
        {isLoading && <Overlay />}
      </section>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    userData: state.userData,
    locationData: state.locations,
    defaultState: state.defaultState,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setUsers: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_USER,
        updatedUser: updatedValue,
      });
    },
    setDefaultState: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_DEFAULT,
        updateDefault: updatedValue,
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Email);

